<script>
export default {
  name: 'CompaniesTable',
  props: {
    companies: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
    hasFilters: { type: Boolean, default: false },
  },
  emits: ['view', 'new-survey', 'delete', 'clear-filters'],
  methods: {
    formatDate(value) {
      if (!value) {
        return '-';
      }

      const d = new Date(value);
      const pad = (n) => String(n).padStart(2, '0');

      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    },
  },
};
</script>

<template>
  <div>
    <p v-if="error" class="list-card__error" role="alert">{{ error }}</p>

    <p v-if="loading" class="list-card__state">Chargement des entreprises…</p>

    <div v-else-if="companies.length" class="list-card__table-wrap">
      <table class="list-table">
        <thead>
          <tr>
            <th>Raison sociale</th>
            <th>Gouvernorat</th>
            <th>Activité principale</th>
            <th>Création</th>
            <th>Enquêtes</th>
            <th>Date d'ajout</th>
            <th class="list-table__actions-head">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="company in companies" :key="company.id">
            <td
              class="list-table__name"
              data-label="Raison sociale"
              @click="$emit('view', company.id)"
            >
              {{ company.legalName || '-' }}
            </td>
            <td data-label="Gouvernorat">{{ company.governorate || '-' }}</td>
            <td data-label="Activité principale">
              {{ company.mainActivitySector || '-' }}
            </td>
            <td data-label="Création">{{ company.yearFounded || '-' }}</td>
            <td data-label="Enquêtes">{{ company.surveysCount ?? 0 }}</td>
            <td data-label="Date d'ajout">
              {{ formatDate(company.createdAt) }}
            </td>
            <td>
              <div class="list-table__actions">
                <button
                  type="button"
                  class="row-action"
                  title="Voir la fiche"
                  @click="$emit('view', company.id)"
                >
                  <i class="ri-eye-line"></i>
                  Voir
                </button>
                <button
                  type="button"
                  class="row-action"
                  title="Démarrer une enquête pour cette entreprise"
                  data-testid="company-new-survey"
                  @click="$emit('new-survey', company.id)"
                >
                  <i class="ri-file-add-line"></i>
                  Nouvelle enquête
                </button>
                <button
                  type="button"
                  class="row-action row-action--danger"
                  title="Supprimer"
                  @click="$emit('delete', company)"
                >
                  <i class="ri-delete-bin-line"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="list-card__empty">
      <p class="list-card__empty-text">
        {{
          hasFilters
            ? 'Aucune entreprise ne correspond à ces filtres.'
            : 'Aucune entreprise pour le moment.'
        }}
      </p>
      <button
        v-if="hasFilters"
        type="button"
        class="list-card__empty-action"
        @click="$emit('clear-filters')"
      >
        Effacer les filtres
      </button>
    </div>
  </div>
</template>
